import { AppLayout } from '@/components/layout/AppLayout'
import { AtlasPage } from '@/components/ui/AtlasPage'
import { PageTitle } from '@/components/ui/PageTitle'
import { Separator } from '@/components/ui/Separator'
import { PageNumber } from '@/components/ui/PageNumber'
import { Button } from '@/components/ui/Button'
import { useForm, Link } from '@inertiajs/react'

function SessionsNew() {
  const { data, setData, post, processing } = useForm({
    email_address: '',
    password: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/session')
  }

  return (
    <AtlasPage narrow>
      <PageTitle title="Logowanie" subtitle="Wejdź do swojego ogrodu" />
      <Separator />

      <form onSubmit={handleSubmit} className="space-y-md">
        <div>
          <label className="block font-label text-xs text-frame uppercase tracking-wide mb-xs">
            Adres e-mail
          </label>
          <input
            type="email"
            value={data.email_address}
            onChange={(e) => setData('email_address', e.target.value)}
            className="form-input"
            required
            autoFocus
            autoComplete="email"
          />
        </div>

        <div>
          <label className="block font-label text-xs text-frame uppercase tracking-wide mb-xs">
            Hasło
          </label>
          <input
            type="password"
            value={data.password}
            onChange={(e) => setData('password', e.target.value)}
            className="form-input"
            required
            autoComplete="current-password"
          />
        </div>

        <Separator />

        <div className="flex flex-col items-center gap-sm">
          <Button type="submit" disabled={processing}>
            Zaloguj się
          </Button>
          <Link
            href="/passwords/new"
            className="font-label text-xs text-frame underline decoration-frame/30 hover:decoration-frame"
          >
            Zapomniałeś hasła?
          </Link>
        </div>
      </form>

      <PageNumber number={20} />
    </AtlasPage>
  )
}

SessionsNew.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
export default SessionsNew
